const { default: styled } = require('styled-components');

const ShareTable = styled.div``;

const Email = styled.div`
  overflow: overlay;
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 12px;
`;

const HeaderCol = styled.div`
  display: flex;
`;

export { Email, Header, HeaderCol, ShareTable };
